import axios from "../../utils/axios";

export const getPost = async (postId) => {
  const response = await axios.get(`/blogs/${postId}`);

  return response.data;
};
